// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Caixa_IndexInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for GET /caixa (listing)
 */
import { registerContract } from './validate'

export interface Caixa_IndexInput {
franquia_id?: number
status?: string
operador_id?: number
data_inicial?: string
data_final?: string
page?: number
per_page?: number
}

registerContract('Caixa_IndexInput', {
  franquia_id:  { type: 'number',  required: false },
  status:       { type: 'string',  required: false },
  operador_id:  { type: 'number',  required: false },
  data_inicial: { type: 'string',  required: false },
  data_final:   { type: 'string',  required: false },
  page:         { type: 'number',  required: false },
  per_page:     { type: 'number',  required: false },
})
